import { render, staticRenderFns } from "./RegionCoveredList.vue?vue&type=template&id=418f3ec8&scoped=true"
import script from "./RegionCoveredList.vue?vue&type=script&lang=ts"
export * from "./RegionCoveredList.vue?vue&type=script&lang=ts"
import style0 from "./RegionCoveredList.vue?vue&type=style&index=0&id=418f3ec8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418f3ec8",
  null
  
)

export default component.exports